/* ============
 * subscriberList Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  current: [],
  currentClientGroup: 0,
  modifiedClientGroup: [],
  cancelClientGroupAdd: false,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/subscriberList/state.js